import { createFileRoute } from "@tanstack/react-router";
import LandingPage from "@/pages/LandingPage";
import { landingPages } from "@/data/landingPages";
import { landingSchemas, pageHead } from "@/lib/seo";

const c = landingPages["growth-architecture"]!.en!;

export const Route = createFileRoute("/en/services/growth-architecture")({
  head: () =>
    pageHead({
      path: "/en/services/growth-architecture",
      title: c.title,
      description: c.description,
      crumbs: [["Services", "/services"], ["Growth Architecture", "/en/services/growth-architecture"]],
      schemas: landingSchemas(c),
    }),
  component: () => <LandingPage pageKey="growth-architecture" forceLanguage="en" pathOverride="/en/services/growth-architecture" />,
});
